import { replaceAllString } from '../../../../shared_modules/baui-utils';

const validator = require('ui-validator');

const v = validator.validators;

const ssnRequired = (value, key, attributes) => {
  if (Object.prototype.hasOwnProperty.call(attributes, key)) {
    return v.required({ message: 'Enter a valid Social Security Number' })(value, key, attributes);
  }
  return undefined;
};

const ssnValid = (value, key, attributes) => {
  if (Object.prototype.hasOwnProperty.call(attributes, key)) {
    return v.validSSN({ message: 'Enter a valid Social Security Number' })(replaceAllString(value), key, attributes);
  }
  return undefined;
};

const ssnSuspicious = (value, key, attributes) => {
  if (Object.prototype.hasOwnProperty.call(attributes, key)) {
    return v.suspicious({ message: 'Enter a valid Social Security Number' })(value, key, attributes);
  }
  return undefined;
};

const allValidations = {
  ssn: {
    required: ssnRequired,
    validSSN: ssnValid,
    suspicious: ssnSuspicious,
  },
  ssnSecondary: {
    required: ssnRequired,
    validSSN: ssnValid,
    suspicious: ssnSuspicious,
    isNotSameAsPrimarySSN: (value, key, attributes) => {
      if (Object.prototype.hasOwnProperty.call(attributes, key)) {
        return v.notSameAsField({
          target: 'ssn',
          message: 'Social Security Numbers for 1st and 2nd Co-Borrowers cannot be the same',
        })(value, key, attributes);
      }
      return undefined;
    },
  },
};

const validations = fieldName => {
  if (fieldName) {
    return {
      [fieldName]: allValidations[fieldName],
    };
  }

  return allValidations;
};

export default validations;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pages/SSN/SSN.less');